export default "__VITE_ASSET__7e04f81b__"